export default __webpack_public_path__ + "static/media/ResearchPapers.fdc15697.svg";